import React from 'react'
import { css } from '@emotion/css'
import { useIntl } from 'react-intl'
import { Text, Link } from '@contrast-security-inc/design-system-typography'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import {
  IconSettings,
  theme
} from '@contrast-security-inc/design-system-foundations'
import { WithTooltip } from '../../design-system'

const notificationHeaderStyles = css`
  padding: 16px;
  border-bottom: 1px solid ${theme.color.neutral30};
  background-color: ${theme.color.neutral10};

  & h5 {
    margin: 0;
  }
`

interface NotificationHeaderProps {
  isMarkAllAsReadLoading: boolean
  markAllAsRead: () => void
  routeToAccountNotifications: () => void
}

export function NotificationHeader({
  isMarkAllAsReadLoading,
  markAllAsRead,
  routeToAccountNotifications
}: NotificationHeaderProps) {
  const { formatMessage } = useIntl()
  return (
    <Stack
      justifyContent="space-between"
      alignItems="center"
      className={notificationHeaderStyles}
    >
      <Text font="titleH5" color="neutral100" as="h5">
        {formatMessage({ id: 'title_notifications' })}
      </Text>
      <div
        className={css`
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      >
        <div
          className={css`
            padding-right: 8px;
          `}
        >
          <Link
            isDisabled={isMarkAllAsReadLoading}
            testId="mark-all-as-read"
            font="body"
            onClick={() => markAllAsRead()}
          >
            {formatMessage({ id: 'detail_notifications_markAllRead' })}
          </Link>
        </div>
        <div
          className={css`
            padding-left: 8px;
            margin-top: 4px;
          `}
        >
          <WithTooltip
            tiny={true}
            placement="auto"
            renderTooltipContent={() => (
              <Text font="metadata" color="white">
                {formatMessage({ id: 'detail_notifications_manageSettings' })}
              </Text>
            )}
            children={() => (
              <Link
                testId="open-notification-settings"
                onClick={routeToAccountNotifications}
              >
                <IconSettings size="sm" color="neutral100" />
              </Link>
            )}
          />
        </div>
      </div>
    </Stack>
  )
}
